import { ArrowDropDown } from '@mui/icons-material';
import { SVButton } from './core';
import { useState } from 'react';
import { MenuList, MenuItem, Menu } from '@mui/material';
import { TransactionType } from '@/types/transactionRequests';
import { useOwnerSelectFormModal } from '@/hooks/stores/useOwnerSelectFormModal';
import { useTransactionFormModal } from '@/hooks/stores/useTransactionFormModal';

type MoveFundsButtonProps = {
  isFullWidth?: boolean;
  customerId?: string;
  bankAccountId?: string;
};

export default function MoveFundsButton({
  isFullWidth,
  customerId,
  bankAccountId = '',
}: MoveFundsButtonProps) {
  const { openOwnerSelectFormModal } = useOwnerSelectFormModal();
  const { openTransactionFormModal } = useTransactionFormModal();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  function handleClick(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }
  function handleClose() {
    setAnchorEl(null);
  }

  function handleMenuItemClick(type: TransactionType) {
    if (customerId) {
      openTransactionFormModal({ bankAccountId, customerId, type });
    } else {
      openOwnerSelectFormModal({ type, bankAccountId });
    }
  }

  return (
    <>
      <SVButton
        onClick={handleClick}
        fullWidth={isFullWidth}
        endIcon={<ArrowDropDown />}>
        Move Funds
      </SVButton>
      <Menu
        anchorEl={anchorEl}
        id="profile-menu"
        open={open}
        onClick={handleClose}
        onClose={handleClose}>
        <MenuList sx={{ padding: 0 }}>
          <MenuItem
            onClick={() => {
              handleMenuItemClick('deposit');
            }}>
            Request a Deposit
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuItemClick('transfer');
            }}>
            Request a Transfer
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuItemClick('wire');
            }}>
            Request a Wire
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
